module.exports = __webpack_public_path__ + "img/feedback.d594dfb1.png";